import { useMemo } from 'react';

import { hasRoles, useKeycloakContext } from '@wf/keycloak-axios-provider';

import { updateRoles } from '../constants';

function useUpdateAccess() {
  const { getUserData } = useKeycloakContext();

  return useMemo(() => {
    const userRoles = getUserData().roles;

    return hasRoles(updateRoles, userRoles);
  }, [getUserData]);
}

export default useUpdateAccess;
